import React, { PureComponent } from 'react';
import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

// Example data
// const data = [
//   {
//     name: 'Step a', users:,
//   },
//   {
//     name: 'Page B', uv: 3000, pv: 1398, amt: 2210,
//   },

// ];

const colors = ['#8884d8', '#82ca9d', '#ffc658'];
const FunnelChart = ({ data, dataKeys }) =>  {
  return (
    <BarChart
      width={700}
      height={400}
      data={data}
      margin={{
          top: 5, right: 30, left: 20, bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <YAxis domain={[0, 100]} />
      <XAxis dataKey="name" />
      <Tooltip />
      <Legend />
      {
        dataKeys.map((dataKey, idx) => {
          return <Bar label dataKey={dataKey} fill={colors[idx]} unit="%" /> 
        })
      }
    </BarChart>
  );
}

export default FunnelChart;